export type RetryConfig = {
  readonly maxAttempts: number;
  readonly baseDelayMs: number;
  readonly maxDelayMs: number;
  readonly multiplier: number;
};

export type RetryTask = () => Promise<void>;

export type RetryAttemptState = {
  readonly id: string;
  readonly attempt: number;
  readonly nextRetryAt: number | null;
  readonly status:
    | 'pending'
    | 'running'
    | 'scheduled'
    | 'completed'
    | 'failed'
    | 'cancelled';
};

export type RetryDebugState = {
  readonly pendingCount: number;
  readonly attempts: readonly RetryAttemptState[];
};

export interface IRetryEngine {
  retry(task: RetryTask, taskId?: string): Promise<void>;

  cancel(taskId: string): void;

  cancelAll(): void;

  getState(): RetryDebugState;
}

export function calculateBackoffDelay(
  attempt: number,
  config: RetryConfig
): number {
  const delay = config.baseDelayMs * config.multiplier ** (attempt - 1);
  return Math.min(delay, config.maxDelayMs);
}
